// extracted by mini-css-extract-plugin
export var link = "footer-nav-module--link--IKfCA";
export var nav = "footer-nav-module--nav--VoX56";
export var title = "footer-nav-module--title--ByrSf";